export default (error: Error): void => {
  if (error.name !== "NavigationDuplicated") {
    throw error;
  }
};
